import { render, staticRenderFns } from "./memu-detail.vue?vue&type=template&id=6957501d&"
import script from "./memu-detail.vue?vue&type=script&lang=js&"
export * from "./memu-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports